import { EmployeeAlertPriority } from '@/common/graphql';
import { EmployeeAlertPriorityLabels } from '@/common/types';
import { ObjectUtils } from '@/common/utils';

import { EmployeeAlertPriorityBadge } from '../../badge';
import type { ComboboxItemWithFormatted } from '../props';
import { SelectMultiple, type SelectMultipleProps } from '../SelectMultiple';

interface EmployeeAlertPrioritySelectMultipleProps
  extends Omit<SelectMultipleProps<ComboboxItemWithFormatted<EmployeeAlertPriority>>, 'searchable' | 'value'> {
  value: Array<EmployeeAlertPriority> | null | undefined;
}

const sortOrder = [EmployeeAlertPriority.High, EmployeeAlertPriority.Medium, EmployeeAlertPriority.Low];

const data: Array<ComboboxItemWithFormatted<EmployeeAlertPriority>> =
  ObjectUtils.arrayFromEnumValues<EmployeeAlertPriority>(EmployeeAlertPriority)
    .sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b))
    .map(value => ({
      label: EmployeeAlertPriorityLabels[value],
      labelFormatted: <EmployeeAlertPriorityBadge priority={value} />,
      value,
    }));

export const EmployeeAlertPrioritySelectMultiple = ({
  placeholder = 'Priority',
  ...rest
}: EmployeeAlertPrioritySelectMultipleProps) => (
  <SelectMultiple
    {...rest}
    data={data}
    loading={false}
    multipleSelectedLabel={(_, labels) => labels.join(', ')}
    placeholder={placeholder}
    searchable={false}
  />
);
